<template>
	
	<BarArrowButton :flex="true" :large="true" class="linkAccounts " title="Recent Transactions" :href="bankInfo.untaggedTransactionsCurrentCycleCount > 0 ? '/#/Transaction/Bulk?from=' + bankInfo.currentCycleStartDate + '&to=' + bankInfo.today + '&includeNegative=true&includePositive=true' : '/#/money?show=true'" >
		<div class="barArrowButtonSlotContent">
			<a :href="'/#/Transaction/Bulk?from=' + bankInfo.currentCycleStartDate + '&to=' + bankInfo.today + '&includeNegative=true&includePositive=true'">
			<p>You've got <strong>{{ bankInfo.untaggedTransactionsCurrentCycleCount }} new {{ bankInfo.untaggedTransactionsCurrentCycleCount == 1 ? 'transaction' : 'transactions'}}</strong> to tag.</p>
			<div class="centered">
				<v-row>
					<v-col>
						<a :href="determineUrl()">
							<div class="countCircle" style="background: var(--background-color-alt5); color: var(--text-color);">

								<span>To Tag</span>
								<div>{{ bankInfo.untaggedTransactionsCurrentCycleCount }}</div>
							</div>
						</a>
					</v-col>
					<v-col>
						<a href="/#/money?show=true">
							<div class="countCircle" style="background: var(--background-color-alt6); color: var(--text-color);">
								<span v-if="bankInfo.recentTransactions[0][0].timestampString == today">Today</span>
								<span v-if="bankInfo.recentTransactions[0][0].timestampString != today">{{ bankInfo.recentTransactions[0][0].timestampString }}</span>
								<div>{{ bankInfo.recentTransactions[0].length }}</div>
							</div>
						</a>
					</v-col>
					<v-col v-if="bankInfo.recentTransactions[1]">
						<a href="/#/money?show=true">
							<div class="countCircle" style="background: var(--background-color-primary); color: white;">
								<span v-if="bankInfo.recentTransactions[1][0].timestampString == today">Today</span>
								<span v-if="bankInfo.recentTransactions[1][0].timestampString != today">{{ bankInfo.recentTransactions[1][0].timestampString }}</span>
								<div>{{ bankInfo.recentTransactions[1].length }}</div>
							</div>
						</a>
					</v-col>
				</v-row>
				
			</div>
			</a>
		</div>
	</BarArrowButton>
	
</template>

<script>
import BarArrowButton from './BarArrowButton.vue';

export default {
	name: "RecentTransactionsInfoPanel",
	components: {
		BarArrowButton
	},
	props: ['today', 'bankInfo'],
	data() {
		return{
			something: null
		}
	},
	methods: {
		onLoad() {
		},
		determineUrl() {
			console.log('determineUrl called');
			if (this.bankInfo.untaggedTransactionsCurrentCycleCount > 0) {
				return '/#/Transaction/Bulk?from=' + this.bankInfo.currentCycleStartDate + '&to=' + this.bankInfo.today + '&includeNegative=true&includePositive=true';
			} else {
				return '/#/money?show=true';
			}
		}
	},
	computed: {
		bulkTaggingUrl() {
			if (this.bankInfo.untaggedTransactionsCurrentCycleCount > 0) {
				return '/#/Transaction/Bulk?from=' + this.bankInfo.currentCycleStartDate + '&to=' + this.bankInfo.today + '&includeNegative=true&includePositive=true';
			} else {
				return null;
			}
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>


.barArrowButtonSlotContent {
	padding: 20px;
	padding-top: 12px;
	padding-bottom: 5px;
	p {
		margin-top: -5px;
		font-size: 12px;
		color: var(--text-color);
	}
}

.countCircle {
	width: 72px;
	height: 72px;
	border-radius: 50%;
	background-color: var(--text-color);
	justify-content: center;
	align-items: center;
	margin-top: 20px;
	margin-left: auto;
	margin-right: auto;
	text-align: center;
	padding: 12px;
	font-size: 12px;
	color: white;
	div {
		font-size: 24px;
		margin-top: -5px;
		clear:both;
	}
	span {
		font-size: 11px;
	}

}


</style>